<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet class="px-3" v-if="!!storeAggregate.rootData && !!storeDetail.uidItem">
          <v-checkbox
              v-model="currentItem.valid"
              :label="$t('valid')"
              class="mt-3"
          ></v-checkbox>
          <CommonFieldString
              :label="$t('subcategory')"
              v-model="currentItem.subcategory"
              hide-details
          >
          </CommonFieldString>
          <v-tabs>
            <v-tab>Common</v-tab>
            <v-tab-item class="mt-3 ml-3">
              <CommonPartialSelectFromTable
                  :label="$t('category')"
                  v-model="currentItem.category_uid"
                  dto-list-query="CategoryListQueryDTO"
                  :sort-by="['category']"
                  item-text="category"
              >
              </CommonPartialSelectFromTable>
              <v-row>
                <v-col cols="4">
                  <v-checkbox
                      v-model="currentItem.maybe_common"
                      :label="$t('maybe_common')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                      v-model="currentItem.maybe_resistor"
                      :label="$t('maybe_resistor')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="4">
                  <v-checkbox
                      v-model="currentItem.maybe_capacitor"
                      :label="$t('maybe_capacitor')"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <CommonChipCombobox
                    title="Matching"
                    height="400"
                    v-model="currentItem.match_list"
                ></CommonChipCombobox>
              </v-row>
            </v-tab-item>
            <v-tab>SpecAttr</v-tab>
            <v-tab-item class="mt-3">
              <v-row>
                <v-col cols="6">
                  <CoreSubcategoryAttr
                      v-if="!!currentItem && !!currentItem.main_attributes"
                      v-model="currentItem.main_attributes.attr_list"
                      :height="height - 285"
                      :headers="headersAttr"
                      @remove="removeAttr($event)"
                  ></CoreSubcategoryAttr>
                </v-col>
                <v-col cols="6">
                  <CoreSubcategoryAttr
                      v-if="!!storeDetail && !!storeDetail.common && !!storeDetail.common.data.attributes"
                      v-model="storeDetail.common.data.attributes.attr_list"
                      :height="height - 285"
                      :headers="headersCommonAttr"
                      @append="appendAttr($event)"
                  ></CoreSubcategoryAttr>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonFieldText from "@/components/Common/CommonFieldText";
import CommonFieldString from "@/components/Common/CommonFieldString";
import CommonChipCombobox from "@/components/Common/CommonChipCombobox";
import CoreSubcategoryAttr from "@/components/CoreComponent/Subcategory/CoreSubcategoryAttr.vue";

export default {
  name: "CoreSubcategoryDetail",

  props: {
    uidItem: {default: null},
    storeName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoDetailQuery: {default: 'SubcategoryDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SubcategoryActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'SubcategorySaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'SubcategoryValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'SubcategoryBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'CoreSubcategoryTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CoreSubcategoryAttr,
    CommonFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
    CommonFieldText,
    CommonChipCombobox,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  watch: {
  },

  methods: {
    removeAttr(item) {
      this.currentItem.main_attributes.attr_list = this.currentItem.main_attributes.attr_list.filter(
          row => row.group !== item.group || row.shortname !== item.shortname)
    },
    appendAttr(item) {
      let rowExists = this.currentItem.main_attributes.attr_list.some(
          row => row.group === item.group && row.shortname === item.shortname)
      if (!rowExists)
        this.currentItem.main_attributes.attr_list.push(item)
    },
  }
  ,


  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      headersAttr: [
        // {text: '', value: 'append', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'group', value: 'group', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'name', value: 'name', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'shortname', value: 'shortname', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'units name', value: 'units_name', sortable: false, filterable: true, divider: true, width: 50},
        {text: '', value: 'remove', sortable: false, filterable: true, divider: true, width: 10},
      ],
      headersCommonAttr: [
        {text: '', value: 'append', sortable: false, filterable: true, divider: true, width: 10},
        {text: 'group', value: 'group', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'name', value: 'name', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'shortname', value: 'shortname', sortable: false, filterable: true, divider: true, width: 50},
        {text: 'units name', value: 'units_name', sortable: false, filterable: true, divider: true, width: 50},
        // {text: '', value: 'remove', sortable: false, filterable: true, divider: true, width: 10},
      ]
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>